import Reparti from "./Reparti";
export default Reparti;
